// Ported from magicui.design/docs/border-beam — copy-paste component,
// owned code. Real rewrite, not just a TS strip: the upstream version
// leans on Tailwind v4-only syntax (`border-(length:--x)`, `mask-[...]`,
// `mask-intersect`, `bg-linear-to-l`, `from-(--x)`) that Tailwind v3.4
// (this project's version) doesn't parse at all — those classes would
// have silently done nothing, leaving no visible beam. The masking trick
// (two stacked gradients, `mask-composite: intersect`, clipped to
// padding-box vs border-box so only the border ring itself shows through)
// is reimplemented with plain inline styles, which work in any Tailwind
// version since they bypass the utility layer entirely. Motion Path
// animation (`offsetPath`/`offsetDistance`) is unchanged — that's a
// browser API, not a Tailwind feature.
import { motion } from "framer-motion";

export const BorderBeam = ({
  className,
  size = 50,
  delay = 0,
  duration = 6,
  colorFrom = "#2F4A3E", // brand pine
  colorTo = "#A13F2C", // brand rust
  transition,
  style,
  reverse = false,
  initialOffset = 0,
  borderWidth = 1.5,
}) => {
  return (
    <div
      className="pointer-events-none absolute inset-0 rounded-[inherit] border-transparent"
      style={{
        borderWidth,
        WebkitMaskImage:
          "linear-gradient(transparent, transparent), linear-gradient(#000, #000)",
        maskImage:
          "linear-gradient(transparent, transparent), linear-gradient(#000, #000)",
        WebkitMaskComposite: "intersect",
        maskComposite: "intersect",
        WebkitMaskClip: "padding-box, border-box",
        maskClip: "padding-box, border-box",
      }}
    >
      <motion.div
        className={className}
        style={{
          position: "absolute",
          aspectRatio: "1 / 1",
          width: size,
          background: `linear-gradient(to left, ${colorFrom}, ${colorTo}, transparent)`,
          offsetPath: `rect(0 auto auto 0 round ${size}px)`,
          ...style,
        }}
        initial={{ offsetDistance: `${initialOffset}%` }}
        animate={{
          offsetDistance: reverse
            ? [`${100 - initialOffset}%`, `${-initialOffset}%`]
            : [`${initialOffset}%`, `${100 + initialOffset}%`],
        }}
        transition={{
          repeat: Infinity,
          ease: "linear",
          duration,
          delay: -delay,
          ...transition,
        }}
      />
    </div>
  );
};
